import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MembersPage } from "./MembersPage";
import { SingleMemberPage } from "./SingleMemberPage";
import { MemberPlatformBalancePage } from "./MemberPlatformBalancePage";
import { MemberPlatformBalanceCurrencyPage } from "./MemberPlatformBalanceCurrencyPage";
import { MemberLocalMarketPositionsPage } from "./MemberLocalMarketPositionsPage";
import { MemberLocalMarketPositionsSymbolPage } from "./MemberLocalMarketPositionsSymbolPage";
import { MemberGlobalMarketPositionsPage } from "./MemberGlobalMarketPositionsPage";
import { MemberGlobalMarketPositionsSymbolPage } from "./MemberGlobalMarketPositionsSymbolPage";
import { RouteWithPermissionAdmin } from "components/RouteWithPermission";
import { MemberDepositPage } from "./MemberDepositPage";
import { MemberPlatformHistoryPage } from "./MemberPlatformHistoryPage";
import { MemberLocalMarketHistoryPage } from "./MemberLocalMarketHistoryPage";
import { MemberGlobalMarketHistoryPage } from "./MemberGlobalMarketHistoryPage";

export const IntroducingBrokerMembersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MembersPage />} />
      <Route path="/:uid" element={<SingleMemberPage />} />

      <Route
        path="/:uid/platform/balance"
        element={
          <RouteWithPermissionAdmin>
            <MemberPlatformBalancePage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/platform/balance/:currency"
        element={
          <RouteWithPermissionAdmin>
            <MemberPlatformBalanceCurrencyPage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/platform/history"
        element={
          <RouteWithPermissionAdmin>
            <MemberPlatformHistoryPage />
          </RouteWithPermissionAdmin>
        }
      />

      <Route
        path="/:uid/local-market/balance"
        element={
          <RouteWithPermissionAdmin>
            <MemberLocalMarketPositionsPage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/local-market/balance/:symbol"
        element={
          <RouteWithPermissionAdmin>
            <MemberLocalMarketPositionsSymbolPage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/local-market/history"
        element={
          <RouteWithPermissionAdmin>
            <MemberLocalMarketHistoryPage />
          </RouteWithPermissionAdmin>
        }
      />

      <Route
        path="/:uid/global-market/balance"
        element={
          <RouteWithPermissionAdmin>
            <MemberGlobalMarketPositionsPage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/global-market/balance/:symbol"
        element={
          <RouteWithPermissionAdmin>
            <MemberGlobalMarketPositionsSymbolPage />
          </RouteWithPermissionAdmin>
        }
      />
      <Route
        path="/:uid/global-market/history"
        element={
          <RouteWithPermissionAdmin>
            <MemberGlobalMarketHistoryPage />
          </RouteWithPermissionAdmin>
        }
      />

      <Route
        path="/:uid/platform/deposit-address/:currency_id/:payment_network_id"
        element={<MemberDepositPage />}
      />

      <Route
        path="*"
        element={<Navigate to={"/logged/members"} replace={true} />}
      />
    </Routes>
  );
};
